export enum LoginQueryParam {
  COURSE_ID = 'courseId',
  TOKEN = 'token',
  ISBN = 'isbn',
  COURSE_COPY = 'courseCopy',
  PARENT_COURSE_SECTION_ID = 'parentCourseSectionId',
  START_DATE = 'startDate',
  ECR_ID = 'ecrId',
}
